import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPosts } from "../actions/post.actions";
import Card from "./Post/Card";
import { isEmpty } from "./utils/Utils";
import ImageProfil from "./Profil/ImageProfil";
import { getComments } from "../actions/comment.actions";
import { getLikes } from "../actions/likes.actions";
import { PartyPopper } from "lucide-react";
import ProdStats from "./Event/ProdStats";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Thread = ({ socket }) => {
  const usersData = useSelector((state) => state.usersReducer);
  const [loadPost, setLoadPost] = useState(true);
  const [query, setQuery] = useState("");
  const [numberOfPostsToShow, setNumberOfPostsToShow] = useState(5);
  const [showAllPosts, setShowAllPosts] = useState(true);
  const [showTechPosts, setShowTechPosts] = useState(false);
  const [allPosts, setAllPosts] = useState([]);
  const [allPostsTech, setAllPostsTech] = useState([]);
  const posts = useSelector((state) => state.postReducer);
  const dispatch = useDispatch();

  const today = new Date();
  const birthdayUsers = Object.values(usersData).filter((user) => {
    if (!user.birthday) return false;
    const birthday = new Date(user.birthday);
    return (
      birthday.getMonth() === today.getMonth() &&
      birthday.getDate() === today.getDate()
    );
  });

  // Nombre d'années chez Local.fr (le jubilé est aujourd'hui par construction).
  const jubileeYears = (user) =>
    today.getFullYear() - new Date(user.birthday).getFullYear();

  useEffect(() => {
    if (loadPost) {
      dispatch(getPosts());
      dispatch(getComments());
      dispatch(getLikes());
      setLoadPost(false);
    }
  }, [loadPost, dispatch]);

  const handleShowAllPosts = () => {
    setShowAllPosts(true);
    setShowTechPosts(false);
  };

  const handleShowTechPosts = () => {
    setShowAllPosts(false);
    setShowTechPosts(true);
  };

  useEffect(() => {
    const allPostsFiltered = posts.filter(
      (post) =>
        post.texte.toLowerCase().includes(query) &&
        (!post.scheduledDate || new Date(post.scheduledDate) <= new Date())
    );

    setAllPosts(allPostsFiltered);

    const techPostsFiltered = allPostsFiltered.filter(
      (post) => post.status === 4
    );

    setAllPostsTech(techPostsFiltered);
  }, [posts, query]);

  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop, clientHeight, scrollHeight } =
        document.documentElement;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        setNumberOfPostsToShow((prevValue) => prevValue + 5);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    socket?.on("getNotificationPost", () => {
      dispatch(getPosts());
    });
  }, [socket]);

  return (
    <>
      <ProdStats />

      {/* <BandeauComponent /> */}

      {/* <CountdownTimer /> */}

      {birthdayUsers.length > 0 ? (
        <div className="jubilee-banner">
          <div className="jubilee-fx" aria-hidden="true">
            <span className="fw fw-1" />
            <span className="fw fw-2" />
            <span className="fw fw-3" />
            {[...Array(8)].map((_, i) => (
              <span key={i} className={`cf cf-${i + 1}`} />
            ))}
          </div>
          <div className="jubilee-inner">
            <div className="jubilee-head">
              <PartyPopper size={18} />
              <span>
                {birthdayUsers.length > 1 ? "Jubilés du jour" : "Jubilé du jour"}
              </span>
            </div>

            <ul className="jubilee-list">
              {birthdayUsers.map((user) => {
                const years = jubileeYears(user);
                return (
                  <li className="jubilee-person" key={user.id}>
                    <span className="jubilee-avatar">
                      <span className="jubilee-initials">
                        {(user.firstname?.[0] || "") + (user.name?.[0] || "")}
                      </span>
                      <ImageProfil id={user.id} />
                    </span>
                    <span className="jubilee-text">
                      <strong>
                        {user.firstname} {user.name}
                      </strong>
                      <span className="jubilee-sub">
                        {years <= 0 ? (
                          "a rejoint l'équipe aujourd'hui"
                        ) : years === 1 ? (
                          <>
                            fête sa <b>1<sup>re</sup> année</b> chez Local.fr
                          </>
                        ) : (
                          <>
                            fête ses <b>{years} ans</b> chez Local.fr
                          </>
                        )}
                      </span>
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      ) : null}

      <div className="post-container">
        <div className="search_post">
          <div className="search-icon-container">
            <i className="fa-solid fa-magnifying-glass search-icon"></i>
          </div>
          <input
            type="text"
            placeholder=" Rechercher un post"
            className="searchbar_post"
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>
      </div>
      <ToastContainer />
      <div className="thread-container">
        <div className="tabPost">
          <div
            className={`allPost ${showAllPosts ? "active" : ""}`}
            onClick={handleShowAllPosts}
          >
            Tous les posts
          </div>
          <div
            className={`techPost ${showTechPosts ? "active" : ""}`}
            onClick={handleShowTechPosts}
          >
            Posts techniques
          </div>
        </div>
        <div>
          {!isEmpty(posts[0]) &&
            (showAllPosts ? allPosts : allPostsTech)
              .slice(0, numberOfPostsToShow)
              .map((post) => {
                return <Card post={post} key={post.id} socket={socket} />;
              })}
        </div>
      </div>
    </>
  );
};

export default Thread;
